export enum QuestionTypeEnum {
  STANDARD = 'standard',
  PREFILLED = 'prefilled',
}

export enum AnswerTypeEnum {
  YES_NO = 'yes_no',
  TEXTAREA = 'textarea',
}

export interface SurveyQuestionsProps {
  surveyId: string;
  defaultQuestion?: boolean;
  onQuestionsUpdate?: (hasSavedQuestions: boolean, hasUnsaved: boolean) => void;
}

export interface QuestionSection {
  id: string;
  text: string;
  type: QuestionTypeEnum | '';
  answerType?: AnswerTypeEnum | '';
  possibleAnswers?: string[];
  prefilledAnswer?: string;
  description?: string;
  hint: {
    text: string;
    enabled: boolean;
  };
  status: {
    isSaved: boolean;
    isEditable: boolean;
    originalText?: string;
    accessId?: string;
  };
  order: number;
}

export enum SurveyQuestionType {
  STANDARD = 'standard',
  PREFILLED = 'prefilled',
}
